/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as tiktok_descriptor from "../../tiktok_descriptor";
import * as merchant_crm from "../data/merchant_crm";
export { api, tiktok_descriptor, merchant_crm };
import { method, headers, queryStringify } from "../../_util";
export var hertz = /*#__PURE__*/function () {
  function hertz(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = hertz.prototype;
  _proto.CreatorList = function CreatorList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ImportCreator = function ImportCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/import";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ImportCheckCreator = function ImportCheckCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/import_check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.DeleteCreator = function DeleteCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/delete";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorDetailInfo = function CreatorDetailInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/detail_info" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CreatorProductList = function CreatorProductList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/product/list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetCreatorContent = function GetCreatorContent(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/content/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.TagList = function TagList(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/tag/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CreateTag = function CreateTag(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/tag/create";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.DeleteTag = function DeleteTag(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/tag/delete";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.UpdateTag = function UpdateTag(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/tag/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.BindTag = function BindTag(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/tag/bind";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.SubmitBatchTask = function SubmitBatchTask(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/batch_task/submit";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetBatchTaskResult = function GetBatchTaskResult(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/batch_task/result/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CreateCreator = function CreateCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/create";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.TargetCollaborationCreatorList = function TargetCollaborationCreatorList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/target_collaboration/list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CheckMaterial = function CheckMaterial(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/material/check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.BatchSendIMMessage = function BatchSendIMMessage(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/im_messages/batch_send";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetImportCreatorUpperLimit = function GetImportCreatorUpperLimit(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/creator/upper_limit/get";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.BlockCreatorList = function BlockCreatorList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/block_creator/list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreateBlockCreator = function CreateBlockCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/block_creator/create";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.DeleteBlockCreator = function DeleteBlockCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/block_creator/delete";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.QueryBlockCreator = function QueryBlockCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/block_creator/query";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.QueryBlockCreatorToC = function QueryBlockCreatorToC(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm_toc/block_creator/query";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.SearchCreator = function SearchCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/crm/cmp/search";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return hertz;
}();
export var hertzClient = new hertz();